import { render } from "./update_modal.vue?vue&type=template&id=2ffcfb8f"
import script from "./update_modal.vue?vue&type=script&lang=js"
export * from "./update_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__